export default __webpack_public_path__ + "static/media/room-propolis-3.49f256a5.jpg";